import React, { useEffect, useRef } from "react";
import "./ScrollingPoints.css";

const ScrollingPoints = () => {
    const points = [
        "Understand the space instead of guessing from plans",
        "Compare units, floors, and orientations at true scale",
        "Personalise finishes and layouts to match their lifestyle",
        "Build confidence faster and commit sooner",
        "Accelerate bookings without increasing marketing spend",
    ];

    const cardsRef = useRef([]);

    useEffect(() => {
        // Intersection Observer for cards
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("scrollingPoints-animate");
                    }
                });
            },
            { threshold: 0.6 }
        );

        cardsRef.current.forEach((card) => card && observer.observe(card));

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <section className="scrollingPoints-container">
            {/* Section Header */}
            <div className="scrollingPoints-header">
                <h2>What Happens When Buyers Can Explore and Compare Units Immersively</h2>
            </div>

            {/* Sticky Video */}
            <div
                className="scrollingPoints-videoWrapper"
            >
                <video
                    className="scrollingPoints-video"
                    src="./videos/ProjectVideo.mp4"
                    autoPlay
                    muted
                    loop
                    playsInline
                />
            </div>

            {/* Cards */}
            <div className="scrollingPoints-cards">
                {points.map((text, index) => (
                    <div
                        key={index}
                        ref={(el) => (cardsRef.current[index] = el)}
                        className="scrollingPoints-card"
                    >
                        <p>{text}</p>
                    </div>
                ))}
                <hr />
            </div>

        </section>
    );
};

export default ScrollingPoints;